<template>
  <div class="season">
    <loading-state :state="state"></loading-state>
    <div v-if="seasonPoints">
      <h2>{{seasonPoints.name}} Points</h2>
      <cricket-season-menu :showSeason="true" :isMetric="isMetric" :seasonKey="seasonKey"></cricket-season-menu>

      <div v-if="seasonPoints.rounds.length > 0">
        <section
          v-for="round in seasonPoints.rounds"
          v-if="round.groups.length > 0 && round.groups[0].teams.length > 0"
          :key="round.$index">
          <h3>{{round.name}}</h3>
          <div class="sub-content">
            <div class="item compact">
              <div>
                <div class="tag tableview">
                  <table class="expanded min-600">
                    <thead>
                      <tr>
                        <th class="left">Team</th>
                        <th>Played</th>
                        <th>Won</th>
                        <th>Lost</th>
                        <th>Draw/NR</th>
                        <th>NRR</th>
                        <th>Pts</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="group in round.groups"
                        v-if="group.teams.length > 0">
                        <tr :key="group.$index" class="subhead left">
                          <td colspan="7"  v-if="round.groups.length > 1">{{group.name}}</td>
                        </tr>
                        <tr v-for="team in group.teams" class="center" :key="team.key">
                            <td  class="left">
                              <router-link
                                class="clean"
                                :to="{name: isMetric ? 'MetricSeasonTeam' : 'cricketSeasonTeam', params:{key:seasonKey, teamkey:team.season_team_key}}">
                                {{team.name}}</router-link>
                            </td>
                            <td>{{team.played}}</td>
                            <td>{{team.won}}</td>
                            <td>{{team.lost}}</td>
                            <td>{{team.tied}}/{{team.no_result}}</td>
                            <td>{{team.net_run_rate}}</td>
                            <td>{{team.points}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-else>
          <div class="center">
            <p>{{round.name}} Points table not available</p>
          </div>
        </section>
      </div>
      <div v-else>
        <div class="center">
          <p>Points table not available</p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { CricketSeason } from '@/models/cricket/season'
import { DataState, AppState } from '@/state'
import Utils from '@/utils'

export default {
  name: 'season',
   props: {
    isMetric: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      seasonKey: this.$route.params.key,
      seasonPoints: null,
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.seasonKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`cricket_season_${this.seasonKey}_points`)
      AppState.updateTitles(newTitle, newTitle)

      CricketSeason.fetchPoints(this.seasonKey, this.isMetric).then(seasonPoints => {
        const newTitle = `${seasonPoints.name} points`
        AppState.updateTitles(newTitle, newTitle)
        this.seasonPoints = seasonPoints
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.seasonKey = null
      this.seasonPoints = null
    },
    refreshView () {

    },
  }
}
</script>
